<template>
  <div class="search-properties">
    <el-row>
      <el-col :span="4">
        <el-radio-group v-model="dataSearch.type" @change="changeTypeMethod()">
          <el-radio-button label="day">Theo ngày</el-radio-button>
          <el-radio-button label="year">Theo năm</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="4" v-if="dataSearch.type === 'day'">
        <el-date-picker
            format="dd-MM-yyyy"
            style="width: 100%"
            v-model="times"
            type="daterange"
            align="right"
            unlink-panels
            @change="changleData"
            range-separator="-"
            start-placeholder="Ngày bắt đầu"
            :clearable="false"
            end-placeholder="Ngày kết thúc">
        </el-date-picker>
      </el-col>
      <el-col :span="2" v-if="dataSearch.type === 'year'">
        <el-date-picker
            style="width: 100%"
            v-model="dataSearch.year"
            format="yyyy"
            placeholder="Chọn năm"
            type="year"
            @change="changleData"
            :clearable="false">
        </el-date-picker>
      </el-col>
      <el-col :span="4" style="margin-left: 20px">
        <el-select
            style="width: 100%"
            filterable
            clearable
            v-model="dataSearch.transferType"
            placeholder="Loại giao dịch"
            @change="changleData()"
        >
          <el-option
              v-for="item in transferTypeList"
              :key="item.id"
              :value="item.value"
              :label="item.label"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="margin-left: 20px">
        <el-select
            style="width: 100%"
            v-model="dataSearch.belongOnekids"
            @change="changleData()"
        >
          <el-option
              v-for="item in belongOnekidsList"
              :key="item.id"
              :value="item.value"
              :label="item.label"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="margin-left: 20px">
        <el-input
            @clear="changleData"
            clearable
            style="width: 100%"
            placeholder="Nhập số tài khoản"
            v-model="dataSearch.accountNumber"
            @keyup.enter.native="changleData"
            type="number"
        >
          <template #append>
            <el-button
                icon="el-icon-search"
                @click="changleData"
            ></el-button>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <div style="margin-top: 20px">
      <div>
        <el-row :gutter="50" style="margin: 30px 0 10px 0 ">
          <el-col :span="8" style="color: white">
            <div class="grid-content bg-purple">
              <div class="content-line-1 color-1">
                <i class="el-icon-chat-line-square"></i>
                <span v-if="this['loda'].sumBy(this.dataListDB1) !== 0">Tổng số giao dịch: {{
                    this['loda'].sumBy(this.dataListDB1)
                  }}</span>
                <span v-else>Tổng số giao dịch: 0 </span>
              </div>
            </div>
          </el-col>
          <el-col :span="8" style="color: white"
          >
            <div class="grid-content bg-purple">
              <div class="content-line-1 color-3">
                <i class="el-icon-edit-outline"></i>
                <span v-if="this['loda'].sumBy(this.dataListDB2) !== 0">Tổng số giao dịch tiền vào: {{
                    this['loda'].sumBy(this.dataListDB2)
                  }}</span>
                <span v-else>Tổng số giao dịch tiền vào: 0 </span>
              </div>
            </div>
          </el-col>
          <el-col :span="8" style="color: white"
          >
            <div class="grid-content bg-purple">
              <div class="content-line-1 color-4">
                <i class="el-icon-edit-outline"></i>
                <span v-if="this['loda'].sumBy(this.dataListDB3) !== 0">Tổng số giao dịch tiền ra: {{
                    this['loda'].sumBy(this.dataListDB3)
                  }}</span>
                <span v-else>Tổng số giao dịch tiền ra: 0 </span>
              </div>
            </div>
          </el-col>
        </el-row>
        <spinner-custom v-if="loadTransactionVolumeChartDB"/>
        <div v-else>
          <ChartBar
              :key="dataSearch.type"
              v-if="showChartDB"
              :checkLable="true"
              :chartData="dataTransactionVolumeChartDB.chartData"
              :options="dataTransactionVolumeChartDB.options"
          ></ChartBar>
        </div>
        <div>
          <div style="float: right; margin-top: 30px">
            <el-dropdown @command="handleCommand">
              <el-button class="button-bottom" type="success">
                Tác vụ
                <i class="el-icon-caret-bottom"/>
              </el-button>
              <el-dropdown-menu>
                <el-dropdown-item command="exportExcel"
                >Xuất excel
                </el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import ChartBar from "@/views/chartStatistical/chart/ChartBar.vue";
import moment from "moment";
import sePayConnectionService from "@/services/SePayConnectionService";
import {exportToExcelStatistics} from "@/commonFuncion/ExportExcelTransactionVolume";
import NotifyMessage from "@/commonFuncion/NotifyMessage";


export default {
  components: {ChartBar},
  name: "StatisticsChartEmployeeSalary",
  data() {
    return {
      loadTransactionVolumeChartDB: false,
      showChartDB: true,
      dataTransactionVolumeChartDB: {},
      dataListDB1: [],
      dataListDB2: [],
      dataListDB3: [],
      listData: [],
      listDay: [],
      dataSearch: {
        type: "day",
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        transferType: "",
        accountNumber: "",
        year: moment().format("YYYY-MM-DD"),
        belongOnekids: true
      },
      times: [],
      dateMonth: [],
      schoolList: [],
      transferTypeList: [
        {id: 1 , value: "credit", label: "Tiền vào"},
        {id: 2 , value: "debit", label: "Tiền ra"},
      ],
      belongOnekidsList: [
        {id: 1 , value: true, label: "Trong trường"},
        {id: 2 , value: false, label: "Ngoài trường"},
      ],
      exportToExcelData: {
        titleFile: 'THỐNG KÊ SỐ LƯỢNG GIAO DỊCH',
        columnWidths: [10, 30, 30, 30, 30], // Chiều rộng của từng cột
        nameFile: 'Thong_ke_so_luong_giao_dich_' + moment().format("DD-MM-YYYY_hh-mm-ss"),
      },
    }

  },
  async mounted() {
    const today = moment().format('YYYY-MM-DD');
    const tenDaysAgo = moment().subtract(10, 'days').format('YYYY-MM-DD');
    this.dataSearch.startDate = tenDaysAgo;
    this.dataSearch.endDate = today;
    this.times = [this.dataSearch.startDate, this.dataSearch.endDate];
    this.dataSearch.year = new Date(); // hoặc new Date('2025')
    await this.findAllData()
    this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate)
    await this.fillDataDB()
  },
  computed: {
    titleFileWithDateRange() {
      const start = moment(this.dataSearch.startDate).format('DD-MM-YYYY');
      const end = moment(this.dataSearch.endDate).format('DD-MM-YYYY');
      return `THỐNG KÊ SỐ LƯỢNG GIAO DỊCH TỪ ${start} ĐẾN ${end}`;
    },
    completeExportToExcelData() {
      return {
        ...this.exportToExcelData,
        companyInfo: [],
      }
    },
  },

  methods: {
    exportToExcelStatistics,
    async changeTypeMethod() {
      if (this.dataSearch.type === "day") {
        this.dataSearch.year = ""
        this.dataSearch.startDate = moment(this.times[0]).format('YYYY-MM-DD');
        this.dataSearch.endDate = moment(this.times[1]).format('YYYY-MM-DD');
        this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate)
        await this.findAllData()
      }
      if (this.dataSearch.type === "year") {
        this.dataSearch.year = new Date(); // hoặc new Date('2025')
        this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate)
        await this.findAllData()
      }
      await this.fillDataDB()
    },
    async changleData(){
      await this.findAllData()
      this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate)
      await this.fillDataDB()
    },

    async findAllData(){
      this.resetList()
      if (this.dataSearch.type === "day") {
        this.dataSearch.year = ""
      }
      this.dataSearch.startDate = moment(this.times[0]).format('YYYY-MM-DD');
      this.dataSearch.endDate = moment(this.times[1]).format('YYYY-MM-DD');
      const yearValue = this.dataSearch.year
          ? moment(this.dataSearch.year).format('YYYY')
          : "";
      await sePayConnectionService.getTotalTransactionForPlus(this.dataSearch.startDate, this.dataSearch.endDate, this.dataSearch.transferType, this.dataSearch.accountNumber,
          yearValue, this.dataSearch.belongOnekids).then(res => {
        this.dataListDB1 = res.data.data.totalTransactionList
        this.dataListDB2 = res.data.data.totalTransactionMoneyInList
        this.dataListDB3 = res.data.data.totalTransactionMoneyOutList
      }).catch(err => {
        console.log(err);
      })
    },

    generateDataLists(startDate, endDate) {
      this.listDay = [];
      if (this.dataSearch.type === "day") {
        let current = moment(startDate);
        const end = moment(endDate);

        while (current.isSameOrBefore(end)) {
          this.listDay.push(current.format('DD-MM-YYYY'));
          current.add(1, 'day');
        }
      } else {
        this.listDay = this.$funcData.getListMonth()
      }

    },


    resetList() {
      this.dataListDB1 = []
      this.dataListDB2 = []
      this.dataListDB3 = []
    },

    getExcelData() {
      this.listData = [];
      if (this.listDay.length > 0) {
        for (let i = 0; i < this.listDay.length; i++) {
          let object  = {
            label: this.listDay[i],
            totalTransactionMoneyIn: this.dataListDB2[i],
            totalTransactionMoneyOut: this.dataListDB3[i],
            totalTransaction: this.dataListDB1[i],
          }
          this.listData.push(object)
        }
      }
    },
    async handleExportExcel() {
      const title = this.titleFileWithDateRange;
      const fileName = this.exportToExcelData.nameFile;
      this.exportToExcelData.titleFile = title;
      this.exportToExcelData.nameFile = fileName;
      if (this.listData.length > 0){
        this.$confirm(
            " Bạn có chắc chắn muốn xuất file hiện tại?",
            "Thông báo!",
            {
              confirmButtonText: "Có",
              cancelButtonText: "Không",
            }
        ).then(async () => {
          await this.exportToExcelStatistics(this.completeExportToExcelData, this.listData, this.dataSearch.type).then(() =>{
            this.$message({
              message: "Xuất file thành công!",
              type: "success",
              duration: 5000
            });
          })
        })
      }else {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu!")
      }
    },
    handleCommand(command) {
      if (command === "exportExcel") {
        this.getExcelData()
        this.handleExportExcel()
      }
    },
    async fillDataDB() {
      this.dataTransactionVolumeChartDB = {
        chartData: {
          labels: this.listDay,
          datasets: [
            {
              label: "Tổng số giao dịch",
              data: this.dataListDB1,
              backgroundColor: "#6aa5e3",
            },
            {
              label: "Tổng số giao dịch tiền vào",
              data: this.dataListDB2,
              backgroundColor: "#34e527",
            },
            {
              label: "Tổng số giao dịch tiền ra",
              data: this.dataListDB3,
              backgroundColor: "#ac20f8",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: (() => {
              return `Tổng hợp số lượng giao dịch hệ thống ghi nhận`
            })(),
            fontSize: 24,
            fontColor: "#000",
          },
          plugins: {
            datalabels: {
              color: "black",
              anchor: (ctx) => (ctx.datasetIndex === 0 ? "end" : (ctx.dataset.data[ctx.dataIndex] > 0 ? "end" : "start")),
              align: (ctx) => (ctx.datasetIndex === 0 ? "end" : (ctx.dataset.data[ctx.dataIndex] > 0 ? "end" : "start")),
              formatter: value => value !== 0 ? value.toLocaleString() : "",
            },
          },
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  callback: (value) => {
                    return ` ${value.toLocaleString()}`;
                  },
                },
              },
            ],
          },
        },
      };
    },

  },
}
</script>

<style lang="scss" scoped>
.content-line {
  padding: 12px;
  margin-bottom: 5px;
  border-radius: 5px;
}

.content-line-1 {
  padding: 6px;
  margin-bottom: 5px;
  border-radius: 5px;
}

.color-1 {
  background: #6aa5e3;
}

.color-2 {
  background: #fd4803;
}

.color-3 {
  background: #34e527;
}

.color-4 {
  background: #ac20f8;
}

.search-table {
  margin-bottom: 20px;
  z-index: 1;
  display: flex;
  width: 100%;
  gap: 0.3rem;
  flex-wrap: wrap;
}


</style>